module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="google_picker_wrapper">\n	<h2 id="google_picker_heading">' +
((__t = ( I18n.t('uploader.source.label.gphotos') )) == null ? '' : __t) +
'</h2>\n	<p id="google_picker_message" class="google_picker_message">\n		Click below to choose your photos in Google Photos.\n	</p>\n	<p id="google_picker_error" class="google_picker_error" style="display:none;"></p>\n	<button id="google_picker_open" class="google_button google_source_button">\n		Open Google Photos\n	</button>\n	<button id="google_picker_retry" class="google_button google_source_button" style="display:none;">\n		Try again\n	</button>\n</div>\n';

}
return __p
}